import { IconProps } from './icon';

export const OneToOneIcon = (props: IconProps): JSX.Element => {
	const { size = 24, ...extraProps } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			width={size}
			height={size}
			viewBox="0 0 1024 1024"
			stroke="currentColor"
			{...extraProps}
		>
			<path d="m183.05 394.17a348.94 348.94 0 0 0 62.271-31.79 255.07 255.07 0 0 0 55.539-48.527h37.4v388.87h-52.547v-316.4a150.91 150.91 0 0 1-16.55 12.903 229.82 229.82 0 0 1-21.318 12.903q-11.501 6.171-24.123 11.781-12.623 5.61-24.404 9.35zm373.07 54.417a38.148 38.148 0 0 1-10.098 25.993 39.27 39.27 0 0 1-54.978 0 39.457 39.457 0 0 1 0-52.734 39.27 39.27 0 0 1 54.978 0 38.148 38.148 0 0 1 10.098 26.741zm0 223.84a38.148 38.148 0 0 1-10.098 26.554 39.27 39.27 0 0 1-54.978 0 39.457 39.457 0 0 1 0-52.734 39.27 39.27 0 0 1 54.978 0 38.148 38.148 0 0 1 10.098 26.18zm85.833-278.26a348.94 348.94 0 0 0 62.271-31.79 255.07 255.07 0 0 0 55.539-48.527h37.4v388.87h-52.173v-316.4a150.91 150.91 0 0 1-16.55 12.903 229.82 229.82 0 0 1-21.318 12.903q-11.501 6.171-24.123 11.781-12.623 5.61-24.404 9.35z" />
			<g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={5.2} strokeWidth={70}>
				<path d="m235 135h-100v100" />
				<path d="m890 235v-100h-100" />
				<path d="m135 790v100h100" />
				<path d="m790 890h100v-100" />
			</g>
		</svg>
	);
};
